const myStars = () => import('@/views/stars/myStars')
const starsDetails = () => import('@/views/stars/starsDetails')
const sarsOrders = () => import('@/views/stars/sarsOrders')
const starRecord = () => import('@/views/stars/starRecord')
const starRule = () => import('@/views/stars/starRule')
export default [
    { path: '', component: myStars, meta: { title: '星星商城' } },
    { path: '/starsDetails', component: starsDetails, meta: { title: '详情' } },
    { path: '/sarsOrders', component: sarsOrders, meta: { title: '提交兑换订单' } },
    { path: '/starRecord', component: starRecord, meta: { title: '兑换记录' } },
    { path: '/starRule', component: starRule, meta: { title: '如何获取星星' } },

]


// WEBPACK FOOTER //
// ./src/router/stars.js